import { throttle } from "lodash";
import { initLargeContentRowSlider } from "./large-content-row-slider";
import { initCaseStudyCategoryButtons } from "./case-study-category-buttons";
import { initCF7 } from "./cf7";

declare const jQuery: any;
const $ = jQuery;
const $window = $(window);

const loadBackgroundImage: Function = window["iw"].utils.loadBackgroundImage;
const registerScrollDetectEvent: Function = window["iw"].registerScrollDetectEvent;

// Set top banner min height data
$($ => {
    $(".banner-flex-wrap:first-child > .banner").first().trigger("set-min-height", {
        minHeightData: [[0, 300], [768, 400]]
    });
});

// Banner scroll down btn line anim
$($ => {
    const $scrollButton = $(".banner .banner-scroll-down");
    if ($scrollButton.length === 0)
    {
        return;
    }
    $window.on("scroll", throttle(() => {
        const scrollTop: number = $window.scrollTop();
        if (scrollTop > 5)
        {
            $scrollButton.addClass("scrolled");
        }
        else
        {
            $scrollButton.removeClass("scrolled");
        }
    }, 400, { leading: true, trailing: true }));
});

// Banner text fade/shift anim
$($ => {
    const $banner = $(".banner");
    if ($banner.length === 0)
    {
        return;
    }
    let loaded = false;
    const onLoad = () => {
        if (loaded)
        {
            return;
        }
        loaded = true;
        $banner.addClass("show");
        setTimeout(() => {
            $banner.addClass("overflow-visible");
        }, 2000);
    };
    $window.on("load", () => {
        loadBackgroundImage($banner.find(".banner-slideshow-item").first()).then(onLoad);
    });
    setTimeout(onLoad, 100);

    // Anim-hide content on scroll
    // $window.on("scroll", throttle(() => {
    //     const scrollTop: number = $window.scrollTop();
    //     if (scrollTop > 150)
    //     {
    //         $banner.addClass("scrolled");
    //     }
    //     else
    //     {
    //         $banner.removeClass("scrolled");
    //     }
    // }, 400, { leading: true, trailing: true }));
});

// Diagonal content
$($ => {
    const $wraps = $(".gcf-diagonal-content");
    if ($wraps.length === 0)
    {
        return;
    }
    $wraps.each(function () {
        const $wrap = $(this);
        const onPassForward = () => {
            $wrap.addClass("scrolled");
        };
        const onPassBackward = () => {
            $wrap.removeClass("scrolled");
        };
        const getThreshold = () => {
            const y: number = $wrap.offset().top - $window.outerHeight() / 2;
            return y;
        };
        registerScrollDetectEvent(onPassForward, onPassBackward, getThreshold);
    });
});

initLargeContentRowSlider();
initCaseStudyCategoryButtons();
initCF7();
